export default __webpack_public_path__ + "static/media/offgrade-ldpe.eea9fd30.jpg";